import {
	IsString,
	IsUUID,
	IsBoolean,
	IsNumber,
	IsNotEmpty,
	Min,
	ValidateIf,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export class BaseSlideDto {
	@IsBoolean()
	visible: boolean;

	@ValidateIf((o) => o.visible)
	@IsUUID()
	iconImgId: string;

	iconImgVariants: any;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	title: string;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	description: string;

	@IsNumber()
	@Min(0)
	index: number;
}

export class StatSummarySlideDto extends BaseSlideDto {
	@IsBoolean()
	showUniversities: boolean;
}

export class StandingsRecapSlideDto {
	@IsBoolean()
	visible: boolean;

	@IsBoolean()
	showUniversities: boolean;

	@IsNumber()
	@Min(0)
	index: number;
}

export class SubstackSlideDto extends BaseSlideDto {
	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	buttonUrl: string;
}

export class VideoRecapSlideDto {
	@IsBoolean()
	visible: boolean;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	title: string;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	videoLink: string;

	@IsNumber()
	@Min(0)
	index: number;
}

export class JoinNextEventDto extends BaseSlideDto {
	@ValidateIf((o) => o.visible)
	@IsUUID()
	bgImgId: string;

	bgImgVariants: any;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	badgeTag: string;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	buttonLabel: string;

	@ValidateIf((o) => o.visible)
	@IsString()
	@IsNotEmpty()
	buttonUrl: string;
}

export class PostEventCarouselDto {
	@ValidateNested()
	@Type(() => StatSummarySlideDto)
	statSummarySlide: StatSummarySlideDto;

	@ValidateNested()
	@Type(() => StandingsRecapSlideDto)
	standingsRecapSlide: StandingsRecapSlideDto;

	@ValidateNested()
	@Type(() => BaseSlideDto)
	emailNotificationSlide: BaseSlideDto;

	@ValidateNested()
	@Type(() => SubstackSlideDto)
	substackSlide: SubstackSlideDto;

	@ValidateNested()
	@Type(() => VideoRecapSlideDto)
	videoRecapSlide: VideoRecapSlideDto;

	@ValidateNested()
	@Type(() => JoinNextEventDto)
	joinNextEventSlide: JoinNextEventDto;
}
